// assets/travel-booking-form.js

class TravelBookingForm {
  constructor() {
    this.formData = {
      // 修改：添加個人資料欄位
      lastName_en: '',
      firstName_en: '',
      lastName_zh: '',
      firstName_zh: '',
      phone: '',
      email: '',
      // 原有欄位
      specialRequirements: false,
      specialRequirementsText: '',
      foodAllergies: false,
      foodAllergiesText: '',
      medicationAllergies: false,
      medicationAllergiesText: '',
      privacyConsent: false,
      healthConsent: false
    };
    
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    this.form = document.getElementById('booking-form');
    if (!this.form) return;

    this.errorMessage = document.querySelector('.form-error-message');
    this.submitButton = document.querySelector('button[type="submit"]');
    
    // 清除所有輸入欄位的初始值
    const inputs = document.querySelectorAll('.shopify-form__input');
    inputs.forEach(input => {
      input.value = '';
    });

    this.attachEventListeners();
    this.loadSavedData();
    this.setupFormSubmission();
    this.validateFormAndUpdateButton();

    // 修改：更精確的購物車按鈕處理
    const handleCheckoutClick = (e) => {
      const checkoutButton = e.target.closest('#CartDrawer-Checkout, [name="checkout"], [href="/checkout"]');
      if (checkoutButton) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = '/pages/checkout-confirmation';
      }
    };

    // 監聽整個文檔的點擊事件
    document.addEventListener('click', handleCheckoutClick, true);

    // 特別處理購物車 drawer 中的按鈕
    const cartDrawerForm = document.getElementById('CartDrawer-Form');
    if (cartDrawerForm) {
      cartDrawerForm.addEventListener('submit', (e) => {
        e.preventDefault();
        window.location.href = '/pages/checkout-confirmation';
      });
    }
}

  attachEventListeners() {
    // 修改：監聽所有必填輸入欄位的變化
    this.form.querySelectorAll('.shopify-form__input[required]').forEach(input => {
      input.addEventListener('input', () => {
        this.validateFormAndUpdateButton();
        this.updateFormData();
      });
    });

    // 處理複選框變更
    this.form.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      checkbox.addEventListener('change', (e) => {
        const textArea = e.target.closest('.form-group').querySelector('textarea');
        if (textArea) {
          textArea.style.display = e.target.checked ? 'block' : 'none';
        }
        this.validateFormAndUpdateButton();
        this.updateFormData();
      });
    });

    // 處理文本區域變更
    this.form.querySelectorAll('textarea').forEach(textarea => {
      textarea.addEventListener('input', () => {
        this.updateFormData();
      });
    });
  }

  // 修改：新的表單提交處理方法
  setupFormSubmission() {
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      
      if (this.validateForm()) {
        this.updateCartAttributes()
          .then(() => {
            window.location.href = '/checkout';
          })
          .catch(error => {
            console.error('更新購物車時發生錯誤:', error);
            this.showError('提交表單時發生錯誤，請稍後再試。');
          });
      } else {
        this.showError('請填寫所有必填欄位');
        // 滾動到第一個無效的欄位
        this.form.querySelector(':invalid')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  // 修改：更新驗證方法
  validateForm() {
    const requiredInputs = this.form.querySelectorAll('.shopify-form__input[required]');
    const requiredCheckboxes = this.form.querySelectorAll('.form-checkbox[required]');
    
    // 檢查個人資料欄位
    const personalInfoValid = Array.from(requiredInputs).every(input => input.value.trim() !== '');
    
    // 檢查必填的 checkbox
    const checkboxesValid = Array.from(requiredCheckboxes).every(checkbox => checkbox.checked);
    
    // 添加錯誤樣式
    requiredInputs.forEach(input => {
      if (!input.value.trim()) {
        input.classList.add('error');
      } else {
        input.classList.remove('error');
      }
    });

    requiredCheckboxes.forEach(checkbox => {
      if (!checkbox.checked) {
        checkbox.closest('.shopify-form__label').classList.add('error');
      } else {
        checkbox.closest('.shopify-form__label').classList.remove('error');
      }
    });

    return personalInfoValid && checkboxesValid;
  }

  // 修改：添加按鈕狀態更新方法
  validateFormAndUpdateButton() {
    const isValid = this.validateForm();
    if (this.submitButton) {
      this.submitButton.disabled = !isValid;
      if (!isValid) {
        this.submitButton.classList.add('button--disabled');
      } else {
        this.submitButton.classList.remove('button--disabled');
      }
    }
  }

  updateFormData() {
    const formData = new FormData(this.form);
    
    // 更新所有表單欄位值
    for (const [key, value] of formData.entries()) {
      this.formData[key] = value;
    }

    // 更新未選中的複選框
    this.form.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      this.formData[checkbox.name] = checkbox.checked;
    });

    localStorage.setItem('bookingFormData', JSON.stringify(this.formData));
    this.hideError();
  }

  // 修改：更新購物車屬性方法，添加個人資料
  async updateCartAttributes() {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          lastName_en: this.formData.lastName_en || '',
          firstName_en: this.formData.firstName_en || '',
          lastName_zh: this.formData.lastName_zh || '',
          firstName_zh: this.formData.firstName_zh || '',
          phone: this.formData.phone || '',
          email: this.formData.email || '',
          special_requirements: this.formData.specialRequirementsText || '',
          food_allergies: this.formData.foodAllergiesText || '',
          medication_allergies: this.formData.medicationAllergiesText || '',
          health_consent: this.formData.healthConsent ? 'Yes' : 'No',
          privacy_consent: this.formData.privacyConsent ? 'Yes' : 'No'
        }
      })
    });

    return response.json();
  }

  loadSavedData() {
    const savedData = localStorage.getItem('bookingFormData');
    if (savedData) {
      this.formData = JSON.parse(savedData);
      
      // 恢復表單狀態
      Object.entries(this.formData).forEach(([key, value]) => {
        const element = this.form.elements[key];
        if (element) {
          if (element.type === 'checkbox') {
            element.checked = value;
            // 如果有對應的文本區域，顯示/隱藏
            const textArea = element.closest('.form-group').querySelector('textarea');
            if (textArea) {
              textArea.style.display = value ? 'block' : 'none';
            }
          } else {
            element.value = value;
          }
        }
      });
    }
  }

  showError(message) {
    if (this.errorMessage) {
      this.errorMessage.textContent = message;
      this.errorMessage.style.display = 'block';
    }
  }

  hideError() {
    if (this.errorMessage) {
      this.errorMessage.style.display = 'none';
    }
  }
}

// 初始化表單
new TravelBookingForm();